import { render, staticRenderFns } from "./KundeWohnung.vue?vue&type=template&id=7f28e3ec&"
import script from "./KundeWohnung.vue?vue&type=script&lang=js&"
export * from "./KundeWohnung.vue?vue&type=script&lang=js&"
import style0 from "./KundeWohnung.vue?vue&type=style&index=0&id=7f28e3ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports